import { CheckboxColors } from '@components/common';
import { TCheckboxColors } from '@components/common/Checkbox/Checkbox';

import { ETechnologiesValues, TTechnologiesValues } from '@enums/common';

export function getTechnologyColor(technology: TTechnologiesValues): TCheckboxColors {
	return technology === ETechnologiesValues.T_5G
		? CheckboxColors.darkGreen
		: technology === ETechnologiesValues.T_4G_TDD
			? CheckboxColors.orange
			: CheckboxColors.darkPurple;
}
